import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActionType, DynamicDialogConfig, DynamicDialogService, OnTableInit, TableConfig } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DelovodniDokumentPraviloFormComponent } from '../delovodni-dokument-pravilo-form/delovodni-dokument-pravilo-form.component';
import { DelovodniciClient, KonfiguracijaBrojaDelovodnogDokumentaDto, KonfiguracijaBrojaDelovodnogDokumentaTableDto } from '@kodit/core/data-api';

@Component({
  selector: 'kodit-delovodni-dokument-pravila-za-broj',
  templateUrl: './delovodni-dokument-pravila-za-broj.component.html',
  styleUrls: ['./delovodni-dokument-pravila-za-broj.component.scss'],
})
export class DelovodniDokumentPravilaZaBrojComponent
  implements OnInit, OnDestroy, OnTableInit {
  /** Configuration */
  tableConfig: TableConfig;
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.SMALL
  );

  /** Props */
  isLoading = true;
  pravilaTable: KonfiguracijaBrojaDelovodnogDokumentaDto[] = [];
  /** Subscription */
  private _subs: Subscription = new Subscription();

  constructor(private _dialogService: DynamicDialogService, private _client: DelovodniciClient) {}

  ngOnInit(): void {
    this.setTableConfig().then();

    this._load();
  }
  
  private _load() {
    this.isLoading = true;
    this._subs.add(
      this._client.getPravilaZaBrojeve().pipe(finalize(() => (this.isLoading = false))).subscribe((res) => {
        this.pravilaTable = res.data;
      })
    );
  }

  async setTableConfig(): Promise<void> {
    this.tableConfig = new TableConfig({
      tableHeader: 'Pravila za generisanje broja delovodnih dokumenata',
      deleteMessage: 'Da li ste sigurni da želite da obrišete pravilo {param}?',
      multiDeleteMessage:
        'Da li ste sigurni da želite da obrišete izabrana pravila?',
      deleteMessageParams: 'naziv',
      columns: [
        {
          field: 'naziv',
          header: 'Naziv',
          type: 'text',
        },
        {
          field: 'prefiks',
          header: 'Prefiks',
          type: 'text',
        },
        {
          field: 'brojac',
          header: 'Brojač',
          type: 'text',
        },
      ],
      headerActions: [
        {
          type: ActionType.CREATE,
          hasAccessTooltip: 'Unesite pravilo',
          noAccessTooltip: 'Nemate ovlašćenja za unos pravila',
          callback: () => {
            this._setDialogConfig({ id: null }, 'Unos pravila');
          },
        },
      ],
      rowActions: [
        {
          type: ActionType.EDIT,
          hasAccessTooltip: 'Izmenite pravilo',
          noAccessTooltip: 'Nemate ovlašćenja za izmenu pravila',
          shouldDisplayByCondition: (
            rowData: KonfiguracijaBrojaDelovodnogDokumentaTableDto
          ) => {
            return rowData.isEditable;
          },
          callback: (index: number) => {
            this._setDialogConfig({ id: this.pravilaTable[index].id }, 'Izmena pravila');
          },
        },
      ],
    });
  }

  private _setDialogConfig(data: any, header: string) {
    this.dialogConfig.data = data;
    this.dialogConfig.header = header;
    this._openDialog(this.dialogConfig);
  }

  private _openDialog(config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(
      DelovodniDokumentPraviloFormComponent,
      config
    );

    this._subs.add(
      ref.onClose.subscribe((result) => {
        if (result) {
          this._load();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
